import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-unread-msg",
  "use": "icon-unread-msg-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-unread-msg\"><defs><style type=\"text/css\"></style></defs><path d=\"M128 331.392V810.666667h725.333333V327.68L469.077333 597.333333 128 331.392zM747.264 298.666667H223.744l247.978667 193.365333L747.264 298.666667zM938.666667 213.333333v682.666667H42.666667V213.333333h896z\" p-id=\"4860\" /><path d=\"M853.333333 256m-128 0a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z\" p-id=\"4861\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol